module.exports = __webpack_public_path__ + "img/floating-image-2.17b85430.png";